"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Like = _interopRequireDefault(require("@insided/destination/icons/Like"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var TopicLike = function TopicLike(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      displayLikeCount = _ref.displayLikeCount,
      _ref$likeCount = _ref.likeCount,
      likeCount = _ref$likeCount === void 0 ? 0 : _ref$likeCount;
  return (0, _preact.h)("li", {
    className: "post__action-item post-footer-item text--meta ".concat(className !== null && className !== void 0 ? className : ''),
    role: "button",
    tabIndex: 0,
    onClick: onClick
  }, (0, _preact.h)(_Like.default, {
    width: 16,
    height: 16
  }), displayLikeCount ? (0, _preact.h)("span", null, " ", likeCount, " ") : (0, _preact.h)("span", {
    className: "post-footer-item-text"
  }, (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "like"
  })));
};

var _default = TopicLike;
exports.default = _default;